import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import Button from '../Button';


function AreYouSureModal(props) {
  const {
    open,
    message,
    executMethod,
    confirmButtonTag,
    onClose,
    classes: {
      modal,
      modalContent,
      title,
      button,
      span,
    },
  } = props;

  return (
    <Dialog
      maxWidth = {'md'}
      open={open}
      // disableBackdropClick
      onClose={onClose}
      classes={{ paper: modal }}
    >

    <DialogTitle className={title}>Are You Sure?</DialogTitle>

    <DialogContent classes={{ root: modalContent }}>{message}</DialogContent> 
    
    <span className={span}>  
      <Button
        onClick={onClose}
        variant="contained"
        color="primary"
        className={button}
      >
        Cancel
      </Button>
      <Button
        onClick={executMethod}
        variant="contained"
        color="primary"
        className={button}
      >
        {confirmButtonTag || 'YES'}
      </Button>
    </span>
  </Dialog>
  );
}

AreYouSureModal.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  confirmButtonTag: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
    marginBottom: '10px',
  },
  title: {
    marginTop: '10px',
    marginLeft: '10px',
    padding: '5px',
  },
  button: {
    width: '120px',
    margin: '10px',
  },
  span: {
    margin: 'auto',
  },
});

export default withStyles(styles)(AreYouSureModal);
